module.exports = __webpack_public_path__ + "img/Natural.ebf0bdea.jpg";